module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-kawi"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.swipers), function(swiper) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticClass: "imgload",
      attrs: {
        "src": swiper.url,
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-d0c2aa98!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/swiperIndex.vue
// module id = 56
// module chunks = 1